import { Product } from '../../model/product/product.model';
import { URLS } from '../navigation/navigation.data';

// The AI tools (owner 2026-10-19): the first section of /tools and of the footer's Tools column. They are pages
// about prices, not integrations: nothing calls an AI from the site.
export const AI_TOOLS: Product[] = [
  {
    key: 'ai-cost-calculator',
    name: 'AI Cost Calculator',
    shortDescription: 'What an app that uses AI costs a month on every model',
    description: 'Pick what you are building, a chatbot, a coding assistant or document summaries, and see what it costs a month on every AI model.',
    url: URLS.tools.aiCostCalculator,
    logo: './assets/product-lines/tools/ai-cost-card.svg',
  },
  {
    key: 'ai-price-watch',
    name: 'AI Price Watch',
    shortDescription: 'The token price of every AI model on a daily chart',
    description: 'Track the token price of every Claude, GPT, Gemini, Grok, Mistral and DeepSeek model on nine platforms on a daily price chart, and compare every model by how far its price moved.',
    url: URLS.tools.aiPriceWatch,
    logo: './assets/product-lines/tools/ai-price-watch-card.svg',
  },
] as Product[];
